import React, { useState } from "react";
import { Modal, Form, DatePicker, TimePicker, Input, Select, message } from "antd";
import dayjs from "dayjs";
import apiClient from "@/utils/apiClient";

const { TextArea } = Input;
const { Option } = Select;

const AddFollowUpModal = ({ visible, onClose, leadId, customerName, onSuccess }) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    try {
      setSubmitting(true);

      const nextFollowUpDate = values.nextFollowUpDate
        ? values.nextFollowUpDate.format("YYYY-MM-DD")
        : null;

      const nextFollowUpTime = values.nextFollowUpTime
        ? values.nextFollowUpTime.format("HH:mm")
        : "10:00";

      const payload = {
        notes: values.notes,
        nextFollowUpDate,
        nextFollowUpTime,
        status: values.status || "completed",
      };

      const response = await apiClient.post(`/leads/${leadId}/follow-up`, payload);

      if (response.data?.success) {
        message.success("Follow-up recorded successfully!");
        form.resetFields();
        if (onSuccess) onSuccess(response.data.lead);
        onClose();
      } else {
        message.error(response.data?.message || "Failed to record follow-up");
      }
    } catch (error) {
      console.error("Follow-up save error:", error);
      message.error(error.response?.data?.message || "Failed to record follow-up");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title={
        <div>
          <div style={{ fontSize: 16, fontWeight: 700, color: "#111" }}>
            Add Follow-Up
          </div>
          <div style={{ fontSize: 12, color: "#666", fontWeight: 400 }}>
            Lead: {customerName || leadId}
          </div>
        </div>
      }
      open={visible}
      onCancel={onClose}
      onOk={() => form.submit()}
      confirmLoading={submitting}
      okText="Save Follow-Up"
      width={500}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{
          status: "completed",
          nextFollowUpDate: dayjs().add(1, "day"),
          nextFollowUpTime: dayjs("11:00", "HH:mm"),
        }}
      >
        <Form.Item
          name="notes"
          label="Follow-Up Notes / Remarks"
          rules={[{ required: true, message: "Please enter follow-up notes" }]}
        >
          <TextArea
            rows={4}
            placeholder="Enter discussion details, customer response, special requests, etc."
          />
        </Form.Item>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <Form.Item
            name="nextFollowUpDate"
            label="Next Follow-Up Date"
            rules={[{ required: true, message: "Select next follow-up date" }]}
          >
            <DatePicker
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
              disabledDate={(current) =>
                current && current < dayjs().startOf("day")
              }
            />
          </Form.Item>

          <Form.Item
            name="nextFollowUpTime"
            label="Next Follow-Up Time"
            rules={[{ required: true, message: "Select next follow-up time" }]}
          >
            <TimePicker
              style={{ width: "100%" }}
              format="HH:mm"
              minuteStep={15}
              use12Hours
            />
          </Form.Item>
        </div>

        <Form.Item name="status" label="Follow-Up Status">
          <Select>
            <Option value="completed">Completed / Logged</Option>
            <Option value="planned">Planned / Scheduled</Option>
            <Option value="rescheduled">Rescheduled</Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddFollowUpModal;
